"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/activity/projects");
exports.initialState = {
    status: 'STANDBY',
    list: []
};
//#endregion
//#region LENS
const statusLens = monocle.Lens.fromProp('status');
const listLens = monocle.Lens.fromProp('list');
exports.methods = {};
exports.methods[Actions.FETCH_REQUEST] = (state, action) => {
    return statusLens.set('FETCHING')(state);
};
exports.methods[Actions.FETCH_SUCCESS] = (state, action) => fp.function.compose(statusLens.set('FETCHED'), listLens.set(action.payload))(state);
exports.methods[Actions.FETCH_FAILURE] = (state, action) => statusLens.set('FAILED')(state);
exports.methods[Actions.CLEAR] = () => (Object.assign({}, exports.initialState));
//#endregion
//# sourceMappingURL=projects.js.map